import React from 'react';
import {Avatar, CardActionArea, CardContent, CardHeader, Chip} from "@mui/material";
import Typography from "@mui/material/Typography";
import {getDataLabel} from "../../../../utils/TableUtils";
import {capitalizeFirstLetter, capitalizeWords, diffDays} from "../../../../utils/GenericUtils";
import moment from "moment";
import ErrorOutlineTwoToneIcon from "@mui/icons-material/ErrorOutlineTwoTone";
import CheckCircleOutlineTwoToneIcon from "@mui/icons-material/CheckCircleOutlineTwoTone";
import RadioButtonUncheckedTwoToneIcon from "@mui/icons-material/RadioButtonUncheckedTwoTone";
import {amber, green, orange, purple, red} from "@mui/material/colors";
import {calcScore, getLastMonitoraggioSintomi} from "../../focolai/detail/FocolaioCard";
import {useTheme} from "@mui/styles";
import multiavatar from "@multiavatar/multiavatar";
import SVG from "react-inlinesvg";

const ProtocolloCard = ({protocollo, goToProtocollo}) => {
	let theme = useTheme();

	return (
        <React.Fragment>
            <CardActionArea onClick={() => goToProtocollo(protocollo)}>
				<CardHeader
					style={{paddingBottom: 2}}
					title={<Typography variant={"subtitle1"}><b> Protocollo {protocollo.id}</b></Typography>}
					subheader={<Typography variant={"body2"} color={"textSecondary"}>
						Ultima modifica: <b>{getDataLabel(protocollo?.dataUltimaModifica)}</b> da parte
						di <b>{protocollo.lastModify}</b>
					</Typography>}
				/>
				<CardContent style={{paddingTop: 8}}>
					<div key={protocollo.quarantena.id}
					     style={{
						     border: theme.palette.mode === "light" ? "2px solid #f4f4f4" : "2px solid #343434",
						     borderRadius: 24,
						     marginBottom: 5,
						     padding: 8
					     }}>
						<div style={{display: "flex", padding: 5, alignItems: "center", width: "100%"}}>
							<Avatar
								style={{marginRight: 10}}>
								<SVG src={multiavatar(protocollo.quarantena?.soggetto?.codF)}/>
							</Avatar>
							<Typography style={{minWidth: 212, flexGrow: 1}}>
								{protocollo.quarantena.tipo}<br/>
								<b>{capitalizeWords(protocollo.quarantena.soggetto.nome) + " " + capitalizeWords(protocollo.quarantena.soggetto.cognome)}</b>
							</Typography>
							<Typography variant={"body2"} color={"textSecondary"}>
								{moment(protocollo.quarantena.dataInizio).format("DD/MM/YY") + " - " + moment(protocollo.quarantena.dataFine).format("DD/MM/YY") + "  (" + diffDays(new Date(protocollo.quarantena.dataInizio), new Date()) + "/" + diffDays(new Date(protocollo.quarantena.dataInizio), new Date(protocollo.quarantena.dataFine)) + ")"}
							</Typography>
							<Chip label={protocollo.quarantena.stato} style={{marginRight: 10, marginLeft: 10, width: 110}}/>
							<Chip
								icon={calcScore(protocollo.quarantena.monitoraggi, protocollo.quarantena.tipo, protocollo.quarantena.score) >= 3 ?
									<ErrorOutlineTwoToneIcon style={{color: "#FFF"}}/> :
									calcScore(protocollo.quarantena.monitoraggi, protocollo.quarantena.tipo, protocollo.quarantena.score) === 0 ?
										<CheckCircleOutlineTwoToneIcon style={{color: "#FFF"}}/> :
										<RadioButtonUncheckedTwoToneIcon style={{color: "#FFF"}}/>}
								label={"SCORE " + calcScore(protocollo.quarantena.monitoraggi, protocollo.quarantena.tipo, protocollo.quarantena.score)}
								style={{
									marginRight: 10,
									marginLeft: 10,
									padding: 4,
									fontWeight: "bold",
									color: "#FFF",
									backgroundColor: calcScore(protocollo.quarantena.monitoraggi, protocollo.quarantena.tipo, protocollo.quarantena.score) === 0 ? green[600] :
										calcScore(protocollo.quarantena.monitoraggi, protocollo.quarantena.tipo, protocollo.quarantena.score) === 1 ? amber[600] :
											calcScore(protocollo.quarantena.monitoraggi, protocollo.quarantena.tipo, protocollo.quarantena.score) === 2 ? orange[600] :
												calcScore(protocollo.quarantena.monitoraggi, protocollo.quarantena.tipo, protocollo.quarantena.score) === 3 ? red[600] :
													purple[500]
								}}/>
						</div>
						<Typography variant={"body2"} color={"textSecondary"}>
							{protocollo.quarantena.note.replaceAll(/#(\S*)/g, "")}
						</Typography>
						<div>
							{
								protocollo.quarantena.note?.match(/#(\S*)/g)?.map(sintomo => {
									return (
										<Chip
											key={sintomo}
											label={capitalizeFirstLetter(sintomo.replaceAll("_", " "))}
											avatar={<Avatar><b>#</b></Avatar>}
											color={"secondary"}
											style={{
												marginRight: 8,
												marginTop: 8,
											}}/>
									)
								})
							}
							{
								getLastMonitoraggioSintomi(protocollo.quarantena.monitoraggi).map(sintomo => {
									return (
										<Chip
											key={sintomo}
											label={capitalizeFirstLetter(sintomo)}
											avatar={<Avatar><b>#</b></Avatar>}
											color={"secondary"}
											style={{
												marginRight: 8,
												marginTop: 8,
											}}/>
									)
								})
							}
						</div>
					</div>
					<Typography>
						N° protocollo: <b>{protocollo.numeroProtocollo ? protocollo.numeroProtocollo : "- -"}</b>
					</Typography>
				</CardContent>
			</CardActionArea>
        </React.Fragment>
    );
};

export default React.memo(ProtocolloCard);
